// PopupBackdropArea.tsx
import React from "react";
import styles from "./styles.module.scss";
import classNames from "classnames";

export interface PopupBackdropAreaProps {
  onClick: () => void;
  isTransparent?: boolean;
}

export const PopupBackdropArea: React.FC<PopupBackdropAreaProps> = ({ onClick, isTransparent = true }) => {
  return <div className={classNames(styles.backdrop, isTransparent? styles.transparent : styles.colorized)} onClick={onClick} />;
};
